import { component as defineComponent } from 'flightjs';

function entryStatus() {
    this.setStatus = function(status) {
        this.$node.find('[data-entry-status]').attr('data-hidden', true);
        if (status) {
            this.$node.find(`[data-entry-status="${status}"]`).removeAttr('data-hidden');
        }
    };

    this.updateStatus = function(e, entry) {
        if (entry.is_winner) {
            this.setStatus('winner');
        } else if (entry.is_deleted) {
            this.setStatus('deleted');
        } else if (entry.is_withdrawn) {
            this.setStatus('withdrawn');
        } else if (entry.is_eliminated) {
            this.setStatus('declined');
        } else if (!entry.is_seen) {
            this.setStatus('new');
        } else {
            this.setStatus(null);
        }
    };

    this.after('initialize', function() {
        this.on('dataEntryUpdated', this.updateStatus);
    });
}

export default defineComponent(entryStatus);



// WEBPACK FOOTER //
// ./src/web/js/entry/ui/entry-status.js